import React from "react";
import {
  fetchUniqueItemsCount,
  searchItems,
} from "slices/discovery/actions/theme";
import { useDispatch, useSelector } from "react-redux";
import { showModal } from "slices/app/actions/modals";
import { modalTypes } from "constants/types";
import { searchWarningConfirmationModal } from "components/Modal/confModalTypes";
import SearchBar from "components/SearchBar/searchBar";
import {
  applyFilter,
  clearSearchAndFilterState,
} from "slices/discovery/actions/filters";
import { setSearch, setSearchTerm } from "slices/discovery/discoverySlice";
import { addToJobQueue } from "slices/app/appSlice";

const DiscoverySearchBar = () => {
  const dispatch = useDispatch();

  const { searchTerm, filterView, filterType, filterDocID } = useSelector(
    (state) => state.discovery.config
  );

  const handleSubmit = (text) => {
    if (text.length < 1) {
      const message = "Search term should contain at least 1 character";

      dispatch(
        showModal(
          modalTypes.CONFIRMATION,
          searchWarningConfirmationModal(message, dispatch)
        )
      );
    } else {
      dispatch(searchItems(text));
    }
  };

  const handleClear = () => {
    dispatch(addToJobQueue("genericJob"));
    setTimeout(() => {
      dispatch(setSearch(false));
      dispatch(setSearchTerm(""));

      if (filterView) {
        dispatch(applyFilter(filterType, filterDocID));
        dispatch(fetchUniqueItemsCount(filterType, filterDocID));
      } else {
        dispatch(fetchUniqueItemsCount());
        dispatch(clearSearchAndFilterState());
      }
    }, 0);
  };

  return (
    <div
      className="categories__header__search_bar_wrapper"
      data-testid="discovery-search-bar"
    >
      <SearchBar
        searchMode={searchTerm !== ""}
        textFromProps={searchTerm}
        clearButtonTitle="Clear search results"
        onSubmit={handleSubmit}
        onClear={handleClear}
      />
    </div>
  );
};

export default DiscoverySearchBar;
